import Button, { ButtonVariant } from '@atoms/Button/Button';
import classNames from 'classnames';

interface Props {
  readonly onLike: () => void;
  readonly isCard?: boolean;
  readonly isLiked: boolean;
  readonly variant?: ButtonVariant['variant'];
}

const LikeButton = ({
  onLike,
  isLiked,
  isCard = true,
  variant = 'white',
}: Props) => {
  return (
    <div
      className={classNames({
        'tw-absolute tw-left-2.5 tw-top-2.5 md:tw-left-xs md:tw-top-xs': isCard,
      })}
    >
      <Button
        iconClasses="tw-shrink-0 tw-absolute"
        variant={variant}
        modifier={variant === 'white' ? 'fill' : 'outline'}
        iconName={isLiked ? 'heart-activated' : 'heart'}
        iconSize="1rem"
        buttonClasses="tw-w-sm !tw-h-sm md:tw-w-md md:!tw-h-md tw-z-20"
        onClick={onLike}
        aria-label="Add to favorites"
      />
    </div>
  );
};

export default LikeButton;
